import './styles/Footer.css'

function Footer() {
    return (
        <></>
    );
}

export default Footer;